import store from '@/store'
import Vue from 'vue'

Vue.prototype.$store = store
